import type { Response } from '../../types';

export function defaultValidateStatus({ status }: Response) {
    return Boolean(status && status >= 200 && status <= 299);
}
